import { render, staticRenderFns } from "./dialogInsureNumber.vue?vue&type=template&id=0f624f4e&scoped=true&"
import script from "./dialogInsureNumber.vue?vue&type=script&lang=js&"
export * from "./dialogInsureNumber.vue?vue&type=script&lang=js&"
import style0 from "./dialogInsureNumber.vue?vue&type=style&index=0&id=0f624f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f624f4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f624f4e')) {
      api.createRecord('0f624f4e', component.options)
    } else {
      api.reload('0f624f4e', component.options)
    }
    module.hot.accept("./dialogInsureNumber.vue?vue&type=template&id=0f624f4e&scoped=true&", function () {
      api.rerender('0f624f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insuranceCenter/components/other/dialogInsureNumber.vue"
export default component.exports